import React, { useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { Label, Icon } from '@nooz-optics/nooz-components-lib';
import { UserState } from 'utils/recoil/user';
import { alertState } from 'utils/recoil/snackbar';
import { withLocale } from 'utils/hocs';
import NoozApi from '../../../../services/NoozApi';
import { Disclosure } from '../../../UI/Navigation/Disclosure/disclosure';
import { ProfileAddressCreateForm } from './AddressCreate/addressCreate';
import { ProfileAddressUpdateForm } from './AddressUpdate/addressUpdate';
import { UserDetailsHeader } from '../Header/userDetailsHeader';
import { AddressCard } from '../AddressCard/addressCard';
import { Button } from '../../../UI/Elements';

export const ProfileAddresses = withLocale(
  ({ createForm, updateForm, label }) => {
    const [user, setUser] = useRecoilState(UserState);
    const [alert, setAlert] = useRecoilState(alertState);

    const isOneAddressOnly = user.addresses?.length === 1;
    const isDefaultAddress = user.defaultAddress?.id;

    const onAddressDelete = (id) => {
      setUser({ ...user, isLoading: true });

      if (typeof window !== 'undefined') {
        NoozApi.delete(`/addresses/customer/${id}`)
          .then(() => NoozApi.get('/customers/current'))
          .then((response) => {
            setUser({ ...user, isLoading: false });

            if (response.data) {
              setAlert({
                ...alert,
                show: true,
                type: 'success',
                title: updateForm.successLabels[0].text,
              });
              setUser({ ...user, ...response.data });
            }
          })
          .catch((error) => {
            setAlert({
              ...alert,
              show: true,
              type: 'error',
              title: `${updateForm.errorLabels[0].text} : ${error?.message}`,
            });
            setUser({ ...user, isLoading: false });
          });
      }
    };

    return (
      <div className='w-full pb-20'>
        <UserDetailsHeader label={label} />
        {/* List of user address */}
        {user.addresses &&
          user.addresses &&
          user.addresses.map((address) => {
            const isSelectedAddress =
              isOneAddressOnly || address?.id === isDefaultAddress;

            const addressComponent = (
              <div className='flex w-full justify-between items-center'>
                <div className='flex items-center'>
                  <Icon
                    iconKey='HiOutlineStar'
                    color={{
                      classname: isSelectedAddress ? 'yellow-500' : 'gray-300',
                    }}
                    size='2xl'
                  />
                  <div className='pl-5 flex flex-col items-start text-left'>
                    <Label
                      weight='medium'
                      text={address?.node?.address1}
                    />
                    <Label
                      weight='light'
                      color={{ classname: 'gray-700' }}
                      text={`${address?.node?.zip} ${address.node?.city}`}
                    />
                  </div>
                </div>
                <div className='pl-5'>
                  <Button
                    onClick={() => {
                      onAddressDelete(address?.node?.id);
                    }}
                    type='contained'
                    icon={{
                      iconKey: 'HiOutlineTrash',
                      size: '2xl',
                      color: { classname: 'primary' },
                    }}
                  />
                </div>
              </div>
            );

            return (
              <div className='pb-5'>
                <AddressCard>
                  <Disclosure
                    isOpen={false}
                    button={addressComponent}
                    chevronIcon={
                      <Icon
                        iconKey='HiChevronDown'
                        size='2xl'
                        color={{ classname: 'primary' }}
                      />
                    }>
                    <div className='py-4 pt-8'>
                      <ProfileAddressUpdateForm
                        {...updateForm}
                        address={address.node}
                      />
                    </div>
                  </Disclosure>
                </AddressCard>
              </div>
            );
          })}
        {/* New address */}
        <AddressCard>
          <Disclosure
            isOpen={false}
            button={
              <Label
                weight='medium'
                text={createForm.submitButton.label?.text}
              />
            }
            chevronIcon={
              <Button
                type='contained'
                icon={{
                  iconKey: 'HiPlusCircle',
                  size: '3xl',
                  color: { classname: 'primary' },
                }}
              />
            }>
            <div className='py-4 pt-8'>
              <ProfileAddressCreateForm {...createForm} />
            </div>
          </Disclosure>
        </AddressCard>
      </div>
    );
  }
);
